import React, { useState, useCallback } from 'react';
import { Button, AutoAwesomeIcon, Spinner, Textarea } from 'tuui';
import { FormField } from 'taboola-ultimate-ui';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './chat.module.scss';

export const ChatInput = ({ onUserInput, disabled = false }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const { formatMessage } = useIntl();
    const placeholder = formatMessage({
        id: 'landing.pages.form.chat.input.placeholder',
        defaultMessage: 'Chat here...',
    });

    const handleSubmit = useCallback(async () => {
        const trimmedValue = inputValue?.trim();
        if (trimmedValue && !isLoading) {
            setIsLoading(true);
            setInputValue('');

            if (onUserInput) {
                await onUserInput(trimmedValue);
            }

            setIsLoading(false);
        }
    }, [inputValue, isLoading, onUserInput]);

    const handleChange = useCallback(event => {
        setInputValue(event.target.value);
    }, []);

    const handleKeyPress = useCallback(
        async event => {
            if (disabled) {
                return;
            }
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                await handleSubmit();
            }
        },
        [handleSubmit, disabled]
    );

    const isSubmitDisabled = disabled || (!inputValue && !isLoading);

    return (
        <div className={styles['chat-input-container']}>
            <FormField inputId="chat-input">
                <div className={styles['input-container']}>
                    <div className={styles['textarea-container']}>
                        <Textarea
                            value={inputValue}
                            placeholder={placeholder}
                            disabled={disabled}
                            onChange={handleChange}
                            onKeyPress={handleKeyPress}
                            className={styles['textarea']}
                            maxRows={8}
                            data-metrics-event-name={GTM_EVENTS.USABILITY}
                            data-metrics-component="chat-input"
                        />
                    </div>
                    <Button onClick={handleSubmit} className={styles['textarea-submit']} disabled={isSubmitDisabled}>
                        <FormattedMessage id="landing.pages.form.chat.input.submit" defaultMessage="Send" />
                        {isLoading ? (
                            <Spinner className={styles['loading']} size={16} color="disabled" />
                        ) : (
                            <AutoAwesomeIcon />
                        )}
                    </Button>
                </div>
            </FormField>
        </div>
    );
};
